import { createFileRoute } from "@tanstack/react-router";
import { WritingProgressPage } from "@client/components/doc-generation/writing-progress-page";

export const Route = createFileRoute("/_app/doc-generation/$taskId/writing")({
  component: WritingProgress,
});

function WritingProgress() {
  const { taskId } = Route.useParams();
  return <WritingProgressPage taskId={taskId} />;
}
